import { Box, Space, Sx, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React, { PropsWithChildren } from 'react'
import Fade from 'react-reveal/Fade'

export interface SectionPlaceholderProps {
  title?: string
  subTitle?: string
  showBorder?: boolean
  customStyles?: Sx
  titleColor?: string
  subtitleColor?: string
  fluid?: boolean
  anchorClassName?: string
}

export const SectionPlaceholder: React.FC<PropsWithChildren<SectionPlaceholderProps>> = props => {
  const {
    title,
    subTitle,
    children,
    customStyles,
    showBorder = true,
    titleColor: tColor,
    subtitleColor: sColor,
    fluid = false,
    anchorClassName,
  } = props
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  const titleColor = tColor ?? theme.colorScheme === 'dark' ? theme.colors.gray[2] : theme.colors.gray[8]
  const subtitleColor = sColor ?? (theme.colorScheme === 'dark' ? theme.colors.blue[4] : theme.primaryColor)

  return (
    <Box
      className={anchorClassName}
      sx={{
        border: 'none',
        paddingInline: fluid || isMobile ? 0 : 150,
        paddingBlock: '6rem',
        textAlign: 'center',
        minHeight: '20rem',
        borderBottom: showBorder
          ? `1px solid ${theme.colorScheme === 'dark' ? theme.colors.gray[8] : theme.colors.gray[4]}`
          : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.colorScheme === 'dark' ? '#121212' : '#FEFEFE',
        ...customStyles,
      }}
    >
      <Fade bottom>
        <Title color={titleColor}>{title}</Title>
        <Space h="xs" />
        <Title order={3} color={subtitleColor} px={4}>
          {subTitle}
        </Title>
      </Fade>
      <Space h="xs" />
      <Box my={'2rem'}>{children}</Box>
    </Box>
  )
}
